import { render, staticRenderFns } from "./LKRoadmapsFeedModalHistoryTable.vue?vue&type=template&id=96e145ea&"
import script from "./LKRoadmapsFeedModalHistoryTable.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedModalHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedModalHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports